// src/pages/WhiteLabel.jsx
import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  MenuItem, Paper, Select, InputLabel, FormControl,
  Checkbox, FormControlLabel, Card, CardContent,
  InputAdornment, IconButton, Tooltip
} from "@mui/material";
import api from "../services/api";
import VpnKeyIcon from '@mui/icons-material/VpnKey';

const COR_OPTIONS = [
  "Green", "Red", "Yellow", "Blue", "Amber", "BlueDark", "BlueGrey", "Brown",
  "Cyan", "DeepOrange", "DeepPurple", "Grey", "Indigo", "LightBlue", "Lime",
  "Orange", "Pink", "Purple", "Teal"
];

const TESTE_OPTIONS = [
  "Sem teste", "Teste de 01 dia", "Teste de 03 dias", "Teste de 07 dias", "Teste de 15 dias", "Teste de 30 dias"
];

function getUserId() {
  return localStorage.getItem('id_usuario');
}

export default function WhiteLabel() {
  const [form, setForm] = useState({
    CodVendedorVideo: "",
    TelSuporte: "",
    TelSuportePrioritario: "",
    NomeEmpresa: "",
    TestarPrograma: "",
    Cor: "",
    LinkDriveDownloads: "", // << NOVO
    PopupTitulo: "",
    PopupEnviar: false,
    PopupLink: "",
    LinkDoCanalYouTube: "",
  });

  const [imagemFile, setImagemFile] = useState(null);
  const [imagemPreview, setImagemPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      const id_usuario = getUserId();
      if (!id_usuario) return alert("Usuário não identificado.");

      try {
        const res = await api.get("/whitelabel", { params: { id_usuario } });
        setForm({
          CodVendedorVideo: res.data.CodVendedorVideo || (localStorage.getItem('chave_usuario') || ""),
          TelSuporte: res.data.TelSuporte || "",
          TelSuportePrioritario: res.data.TelSuportePrioritario || "",
          NomeEmpresa: res.data.NomeEmpresa || "",
          TestarPrograma: res.data.TestarPrograma || "",
          Cor: res.data.Cor || "",
          LinkDriveDownloads: res.data.LinkDriveDownloads || "", // << NOVO
          PopupTitulo: res.data.PopupTitulo || "",
          PopupEnviar: res.data.PopupEnviar === "S" || res.data.PopupEnviar === true,
          PopupLink: res.data.PopupLink || "",
          LinkDoCanalYouTube: res.data.LinkDoCanalYouTube || "",
        });

        if (res.data.imagemAviso) {
          setImagemPreview(`data:image/png;base64,${res.data.imagemAviso}`);
        }
      } catch (err) {
        alert("Erro ao carregar dados do WhiteLabel.");
      }
    };
    fetch();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImagemFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = (ev) => setImagemPreview(ev.target.result);
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const id_usuario = getUserId();
      if (!id_usuario) {
        alert("Usuário não identificado."); setLoading(false); return;
      }

      const formData = new FormData();
      formData.append("id_usuario", id_usuario);

      Object.entries(form).forEach(([key, val]) => {
        if (typeof val === "boolean") {
          formData.append(key, val ? "S" : "");
        } else {
          formData.append(key, val ?? "");
        }
      });

      if (imagemFile) formData.append("imagemAviso", imagemFile);

      await api.post("/whitelabel", formData, { params: { id_usuario } });
      alert("Salvo com sucesso!");
    } catch (err) {
      alert("Erro ao salvar WhiteLabel");
    }
    setLoading(false);
  };

  return (
    <Box p={2} component={Paper} elevation={3} maxWidth={950} mx="auto" mt={3}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        White Label
      </Typography>

      <Grid container spacing={2}>
        {/* Card 1: Dados da empresa */}
        <Grid item xs={12} md={6}>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" mb={2} color="primary">
                Dados da empresa
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Nome da sua empresa"
                    name="NomeEmpresa"
                    value={form.NomeEmpresa}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth margin="dense">
                    <InputLabel>Cor do programa</InputLabel>
                    <Select
                      label="Cor do programa"
                      name="Cor"
                      value={form.Cor || ""}
                      onChange={handleChange}
                    >
                      {COR_OPTIONS.map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Chave do usuário para os vídeos"
                    name="CodVendedorVideo"
                    value={form.CodVendedorVideo}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Preencher com minha própria chave de usuário">
                            <IconButton
                              size="small"
                              onClick={() => {
                                const minhaChave = localStorage.getItem('chave_usuario') || '';
                                setForm(prev => ({ ...prev, CodVendedorVideo: minhaChave }));
                              }}
                            >
                              <VpnKeyIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="WhatsApp do seu suporte técnico"
                    name="TelSuporte"
                    value={form.TelSuporte}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="WhatsApp do seu suporte prioritário"
                    name="TelSuportePrioritario"
                    value={form.TelSuportePrioritario}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth margin="dense">
                    <InputLabel>Deixar o cliente testar</InputLabel>
                    <Select
                      label="Deixar o cliente testar"
                      name="TestarPrograma"
                      value={form.TestarPrograma || ""}
                      onChange={handleChange}
                    >
                      {TESTE_OPTIONS.map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* NOVO: Link do Drive */}
                <Grid item xs={12}>
                  <TextField
                    label="Link do Google Drive (Downloads)"
                    name="LinkDriveDownloads"
                    value={form.LinkDriveDownloads}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                    placeholder="https://drive.google.com/drive/folders/..."
		    helperText="Link do Drive do REPRESENTANTE. Quando uma licença é criada e o sistema envia o e-mail automático (ex.: via webhook), este link é usado no campo “Acesse o programa”. Se estiver vazio, usa o padrão do sistema."

                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Canais/Playlists do YouTube (1 por linha)"
                    name="LinkDoCanalYouTube"
                    value={form.LinkDoCanalYouTube}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                    multiline
                    minRows={4}
                    helperText="Aceita @handle, UC..., URLs de canal/playlist (list=PL...) e IDs PL/UU/LL. Uma por linha."
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Card 2: Configurações do POP UP */}
        <Grid item xs={12} md={6}>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" mb={2} color="primary">
                Configurações do POP UP
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Título do POP UP"
                    name="PopupTitulo"
                    value={form.PopupTitulo}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Foto do POP UP (Tamanho sugerido: 800x400)
                  </Typography>

                  <Button variant="outlined" component="label" sx={{ mb: 1 }}>
                    IMAGEM
                    <input type="file" accept="image/*" hidden onChange={handleImage} />
                  </Button>

                  {imagemPreview && (
                    <Box sx={{ mt: 1 }}>
                      <img
                        src={imagemPreview}
                        alt="Imagem Aviso"
                        style={{ maxHeight: 120, maxWidth: 300, borderRadius: 10 }}
                      />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Link do botão na tela do aviso"
                    name="PopupLink"
                    value={form.PopupLink}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!form.PopupEnviar}
                        onChange={handleChange}
                        name="PopupEnviar"
                      />
                    }
                    label="Enviar este POP UP aos clientes"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box mt={3} display="flex" justifyContent="center">
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? "Salvando..." : "SALVAR"}
        </Button>
      </Box>
    </Box>
  );
}
